import {
  Filter,
  FilterMatchingType,
} from "interfaces/filters";

export const filtersDefs: Array<Filter> = [
  {
    name: 'contractName',
    path: ['contractName', 'providedValue'],
    label: 'Contract Name',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
  {
    name: 'contractCustomer',
    path: ['contractCustomer', 'providedValue'],
    label: 'Customer',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
  {
    name: 'contractBookingDate',
    path: ['contractBookingDate', 'providedValue'],
    label: 'Booking Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'contractStartDate',
    path: ['contractStartDate', 'providedValue'],
    label: 'Start Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'contractEndDate',
    path: ['contractEndDate', 'providedValue'],
    label: 'End Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'contractCancelDate',
    path: ['contractCancelDate', 'providedValue'],
    label: 'Cancel Date',
    matching: FilterMatchingType.DATE_RANGE,
    value: [],
  },
  {
    name: 'contractCRMID',
    path: ['contractCRMID', 'providedValue'],
    label: 'CRM ID',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
  {
    name: 'contractTags',
    path: ['contractTags', 'providedValue'],
    label: 'Tags',
    matching: FilterMatchingType.STRING_INCLUDES,
    value: '',
  },
];
